import { render, staticRenderFns } from "./AdminView.vue?vue&type=template&id=12b48a19"
import script from "./AdminView.vue?vue&type=script&lang=ts"
export * from "./AdminView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports